import React from "react";
import Success from "../home/component/Success";
import Footer from "../header/Footer";
import TeamDetail from "./components/TeamDetail";
import JoinTheTeam from "./components/Jointheteam";
import Heroteam from "./components/Heroteam";
import useScrollAnimation from "component/useScrollAnimation";


function OurTeam() {
  useScrollAnimation();

  return (
    <>
      <Heroteam/>
      <TeamDetail/>

      <JoinTheTeam/>
        <Success />
        <Footer />
      
    </>
  );
}

export default OurTeam;
